import React from "react";
import { authenticate, logoutUser } from "../services/user.service";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, isAuthenticated: true };
    case "SIGN_OUT_SUCCESS":
      return { ...state, isAuthenticated: false };
    case "LOGIN_FAILURE":
      return { ...state, isAuthenticated: false };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
const notify = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

function UserProvider({ children }) {
  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: !!localStorage.getItem("AUTH_TOKEN"),
  });

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error("useUserState must be used within a UserProvider");
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error("useUserDispatch must be used within a UserProvider");
  }
  return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, signOut };

// ###########################################################

function loginUser(dispatch, login, password, history, setIsLoading, setError) {
  if (!!login && !!password) {
    let data = {
      userId: login,
      password: password,
    };
    let body = JSON.stringify(data);
    setError(false);
    setIsLoading(true);
    authenticate(body).then(
      (response) => {
        setIsLoading(false);
        if (response.data.statusCode === 200) {
          let data = response.data.response;
          localStorage.setItem("AUTH_TOKEN", data.token);
          localStorage.setItem("FIRSTNAME", data.firstName);
          localStorage.setItem("LASTNAME", data.lastName);
          localStorage.setItem("EMAIL", data.emailAddress);
          setError(null);
          setIsLoading(false);
          dispatch({ type: "LOGIN_SUCCESS" });
          history.push("/app/dashboard");
        } else {
          setError(null);

          notify(response.data.message);
          // setError(true);
        }
      },
      (error) => {
        notify("Something went wrong");
        dispatch({ type: "LOGIN_FAILURE" });
        // setError(true);
      },
    );
  } else {
    setError(true);
  }
}

function signOut(dispatch, history) {
  // logout service
  logoutUser()
    .then((response) => {
      if (response.data.statusCode === 200) {
        localStorage.clear();
        dispatch({ type: "SIGN_OUT_SUCCESS" });
        history.push("/login");
        window.location.reload();
      } else {
        localStorage.clear();
        window.location.reload();
      }
    })
    .catch((error) => {
      localStorage.clear();
    });
}
